import React, { Component } from 'react';
import Bars from './Bars.jsx';
// import { scaleLinear } from 'd3-scale'
// import { interpolateLab } from 'd3-interpolate'

export default class GroupBars extends Component {
  constructor(props) {
    super(props)
    this.state={
    }
    // this.colorScale = scaleLinear()
    //   .domain([0, this.props.maxValue])
    //   .range(['#F3E5F5', '#7B1FA2'])
    //   .interpolate(interpolateLab)
  }
  render() {
    const { primaryYAxis,secondoryYAxis, primaryXAxis, secondorXAxis, svgDimensions,primaryXAxisPadding,margins,chartConfigWithBar,isGroupColumn,mainDivId,
            xAxisPrimaryCategories,xAxisSecondaryCategories,globalTooltip,globalTooltipData,showColumnGroupChartTooltip,hideColumnGroupChartTooltip } = this.props
    const { height } = svgDimensions;
    
    var that=this;
    return (
      <g className='columnGroupBar'>
          {
            xAxisPrimaryCategories.length && xAxisPrimaryCategories.map(function(d,index){
                d=(d!=null && typeof(d)=='object') ? d.data : d;
                return <g key={index} transform={"translate(" + primaryXAxis.scale(d) + ",0)"}>
                   {chartConfigWithBar.length && chartConfigWithBar.map(function(d1,indexBar){
                    let isGroupDataHaveNegativeValue=d1.data.filter(function(datum){
                              let oriDatum=datum;  
                              if(datum!=null && typeof(datum)=='object'){
                                oriDatum=datum.data;
                              }
                              return oriDatum<0;
                            }).length;
                    isGroupDataHaveNegativeValue=isGroupDataHaveNegativeValue>0 ? 1 : 0;
                     return <Bars yAxisScale={d1.yAxis==1 ? secondoryYAxis : primaryYAxis } 
                        tooltipConfig={d1.tooltipConfig || {}} 
                         xAxisScale={primaryXAxisPadding} groupIndex={indexBar} mainGroupIndex={index} dataLabels={d1.dataLabels || {}}
                         margins={margins} data={[d1.data[index]]} xAxisData={d1.xAxis==1 ? xAxisSecondaryCategories : xAxisPrimaryCategories} fillColor={d1.fillColor}
                         svgDimensions={svgDimensions} key={'Bar_'+indexBar} isGroupColumn={isGroupColumn} tooltip={d1.tooltip} tooltipStyle={d1.tooltipStyle || {}} name={d1.name || ''}
                         xAxisCategory={xAxisPrimaryCategories[index]} id={`${that.props.id}_${index}_${indexBar}`} hoverStyle={d1.hoverStyle || {}}
                         tooltipPosition={d1.tooltipPosition || "default"} onColumnBarClick={d1.onColumnBarClick}
                         globalTooltip={globalTooltip} globalTooltipData={globalTooltipData} primaryXAxis={primaryXAxis}
                         mainDivId={mainDivId} showColumnChartTooltip={showColumnGroupChartTooltip} hideColumnChartTooltip={hideColumnGroupChartTooltip} isGroupDataHaveNegativeValue={isGroupDataHaveNegativeValue}>
                        
                         </Bars>
                   })}
                </g>
              })
          }
          { React.Children.count(this.props.children) ? 
            <g className="columnGroupBarChildComponent">
              { React.Children.map(this.props.children,function(child,index){
                  return (<g key={index}  className="columnGroupBarChildComponent">{child}</g>);
                })
              }
            </g> 
            : null
          }  
      </g>
    )
  }
}
